import { motion } from "framer-motion";
import WaitlistForm from "@/components/dendros/WaitlistForm";

export default function FooterCTA() {
    return (
        <section
            id="footer-cta"
            data-testid="footer-cta-section"
            className="relative py-32 lg:py-40 border-t border-white/5 overflow-hidden"
        >
            {/* Ambient */}
            <div className="absolute inset-0 bg-grid-volt opacity-[0.55]" />
            <div
                className="absolute inset-x-0 bottom-0 h-[340px] blur-[120px] pointer-events-none"
                style={{
                    background:
                        "radial-gradient(ellipse at bottom, rgba(16,185,129,0.28), transparent 70%)",
                }}
            />

            <div className="relative mx-auto max-w-4xl px-6 lg:px-10 text-center">
                <motion.div
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-60px" }}
                    transition={{ duration: 0.6 }}
                >
                    <div className="inline-flex items-center gap-2 rounded-full border border-[#10B981]/25 bg-[#10B981]/[0.06] px-3 py-1 text-[11px] uppercase tracking-[0.25em] font-mono text-[#34D399]">
                        <span className="h-1.5 w-1.5 rounded-full bg-[#10B981] animate-pulse" />
                        Private Alpha · Limited Seats
                    </div>

                    <h2 className="mt-6 font-display text-[40px] sm:text-[54px] lg:text-[72px] font-semibold leading-[1.02] tracking-[-0.03em]">
                        Ready for a{" "}
                        <span className="text-volt-gradient">100% accurate</span>{" "}
                        pipeline?
                    </h2>
                    <p className="mt-6 max-w-xl mx-auto text-[16px] text-neutral-400 leading-relaxed">
                        Join the waitlist. We'll reach out when your seat in
                        the alpha is ready — and walk you through a live Health
                        Scan on your Salesforce org.
                    </p>

                    <div className="mt-10 max-w-2xl mx-auto text-left">
                        <WaitlistForm
                            source="footer"
                            testIdPrefix="footer"
                            showCompanySize
                            buttonLabel="Secure Early Access"
                            inputTestId="footer-email-input"
                            submitTestId="footer-submit-button"
                            sizeTestId="footer-company-size"
                        />
                    </div>

                    <div className="mt-8 flex items-center justify-center gap-5 text-[12px] text-neutral-500">
                        <span className="flex items-center gap-2">
                            <Check /> No credit card
                        </span>
                        <span className="flex items-center gap-2">
                            <Check /> Read-only scan
                        </span>
                        <span className="flex items-center gap-2">
                            <Check /> Cancel anytime
                        </span>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}

function Check() {
    return (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            className="text-[#10B981]"
            fill="currentColor"
        >
            <path d="M6 0a6 6 0 100 12A6 6 0 006 0zm-.8 8.7L2.7 6.2l.9-.9 1.6 1.6 3.2-3.2.9.9L5.2 8.7z" />
        </svg>
    );
}
